// eslint-disable-next-line
export default {
  SUPER_ADMIN: "SuperAdmin",
  PUBLISHER: "Publisher"
};
